import { render, staticRenderFns } from "./discloseEdit.vue?vue&type=template&id=72bcd33c&"
import script from "./discloseEdit.vue?vue&type=script&lang=js&"
export * from "./discloseEdit.vue?vue&type=script&lang=js&"
import style0 from "./discloseEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports